<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong>Status Report</strong>
          </div>

         <b-row class="form-group" v-if="isSuperAdmin == 1 && currentCountry == 'KSA'">
          <b-col sm="6" >
            <b-form-group label="Hub Name" :label-cols="2">
              <b-form-select  v-model="service_id">
                <option value="">--Please Select Hub--</option>
                <option v-for="hub in hublistData"  v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
            </b-form-select> 
            </b-form-group>
          </b-col>
          <!-- <b-col sm="4" >
                 <b-form-select  v-model="service_id">
                      <option value="">--Please Select Hub--</option>
                      <option v-for="hub in hublistData"  v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
                  </b-form-select> 
             
          </b-col> -->
          <b-col sm="2" >     
            <b-button type="submit" size="md" variant="primary" @click="hublistSearch()" > Search</b-button>&nbsp;
            <b-button variant="danger" @click="clearsearch()" :disabled="service_id.length==0"> Clear </b-button>
          </b-col>
         </b-row>

          <b-row>
            <b-col md="12">
              <div>
                <b-tabs content-class="" justified>
                  <b-tab
                    title="To Be OFD"
                    active
                    style="border:1px solid #C8CED3;"
                  >
                    <b-col sm="12" class="text-right">
                      <b-button
                        class="mb-2"
                        v-if="this.totalRows > 0"
                        variant="primary"
                        size="md"
                        @click="downloadCSV('tobeOFD')"
                        >Download
                      </b-button>

                      <p>
                        <b
                          >Total Records :<span style="color:red;"
                            >&nbsp;{{ list_totalRows1 }}</span
                          ></b
                        >
                      </p>
                    </b-col>

                    <b-table
                      responsive
                      class="tableOFD"
                      show-empty
                      stacked="md"
                      :items="data"
                      :fields="fields"
                      :bordered="bordered"
                      thead-class="Collected"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      @filtered="onFiltered"
                      :busy="isBusy1"
                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                      <template slot="show_details" slot-scope="row">
                        <button class="btn btn-primary">
                          <i class="fa fa-download"></i>
                        </button>
                      </template>
                    </b-table>
                    
                    <div class="overflow-auto1">
                      <paginate 
                        :page-count="noofpagesofd"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallbackofd"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                      </paginate>
                    </div>
                  </b-tab>

                  <b-tab title="OFD Expired" style="border:1px solid #C8CED3;">
                    <b-col sm="12" class="text-right">
                      <b-button
                        class="mb-2"
                        v-if="this.totalRows_exp > 0"
                        variant="primary"
                        size="md"
                        @click="downloadCSV('expiredOFD')"
                        >Download
                      </b-button>
                      <p>
                        <b
                          >Total Records :<span style="color:red;"
                            >&nbsp;{{ list_totalRows }}</span
                          ></b
                        >
                      </p>
                    </b-col>

                    <b-table
                      responsive
                      class="tableOFD"
                      show-empty
                      :items="data_exp"
                      :fields="fields_exp"
                      :bordered="bordered"
                      thead-class="Collected"
                      :current-page="currentPage"  :per-page="perPage" 
                      :filter="filter"
                      @filtered="onFiltered"
                      :busy="isBusy"
                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                      <template slot="show_details" slot-scope="row">
                        <button class="btn btn-primary">
                          <i class="fa fa-download"></i>
                        </button>
                      </template>
                    </b-table>

                    <div class="overflow-auto">
                      <paginate 
                        :page-count="noofpages"
                        :page-range="10"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                      </paginate>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
// import Utils from "@/utils";
// import { EventBus } from "./event-bus.js";

// import { defineComponent } from "@vue/composition-api";

export default {
  data: function() {
    return {
      data: [],
      perPage: 20,
      currentPage: 1,
      noofpages:'',
      pageNum:1,
      listingpageno:1,
      pageNumofd:1,
      noofpagesofd:'',
      odflistpageno:1,
      data_exp: [],
      CSVdownload_data: [],
      bordered: true,
      items: [],
      totalRows: 0,
      totalRows_exp: 0,
      isBusy: false,
      isBusy1: false,
      fields: [
        {
          key: "orderid",
          label: "Order ID",
        },
        {
          key: "shippingid",
          label: "Shipping Id",
        },
        {
          key: "shipmentstatus",
          label: "Shipping Status",
        },
        {
          key: "vendor_address",
          label: "Vendor Address",
        },
        {
          key: "shipcity",
          label: "Shipping State",
        },
        {
          key: "shipaddress1",
          label: "Shipping Address",
        },
        {
          key: "billphonenumber",
          label: "Conatct No.",
        },
        { key: "shipfirstname", label: "Shipment First Name" },
      ],

      fields_exp: [
        {
          key: "orderid",
          label: "Order ID",
        },
        {
          key: "shippingid",
          label: "Shipping Id",
        },
        {
          key: "shipmentstatus",
          label: "Shipping Status",
        },
        {
          key: "vendor_address",
          label: "Vendor Address",
        },
        {
          key: "shipcity",
          label: "Shipping State",
        },
        {
          key: "shipaddress1",
          label: "Shipping Address",
        },
        {
          key: "billphonenumber",
          label: "Conatct No.",
        },
        // { key: "show_details", label: "Action" },
      ],
      list_totalRows: 0,
      list_totalRows1: 0,
      countpage: 1,
      hublistData:[],
      service_id : '',
      isSuperAdmin:'',
      currentCountry:'',
    };
  },

  created: function() {
    var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isSuperAdmin=userInfo.is_superadmin;
      console.log("this.isSuperAdmin",this.isSuperAdmin);
      this.currentCountry=`${userInfo.country}`;
      console.log("this.currentCountry",this.currentCountry);

      if(this.isSuperAdmin == 1 && this.currentCountry=='KSA'){
        this.gethublist();
      }else{
        // this.gethublist();
        this.displaydata(this.pageNumofd);
        this.expiredofdfunction(this.pageNum);
       
      }
     
  },

  methods: {
    clickCallbackofd(pageNumofd) {
      // alert(pageNo1);
      this.odflistpageno = pageNumofd;
        console.log("pageNum",this.odflistpageno)
      
      this.displaydata(pageNumofd);

    },

    hublistSearch()
    {
      if(this.service_id != ""){
        this.displaydata(this.pageNumofd);
        this.expiredofdfunction(this.pageNum)
      }else{
        this.$fire({
              text: "Please Select Hub Name",
              type: "warning",
              timer: 30000,
            });
            this.service_id = "";
          this.data=[]
          this.pageNumofd=1;
          this.data_exp=[];
          this.pageNum=1;
          this. list_totalRows= 0;
          this.list_totalRows1=0;

      }
     
    },

    gethublist()
    {
       var userdata = localStorage.getItem("userData");
       var userInfo = JSON.parse(userdata);
      const obj={
        hub_id: `${userInfo.pickuplocationmasterid}`
      }

        this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,obj)
            .then(result => {
              
          if(result.body.returnmsg=='Successful'){
          this.hublistData = result.body.returnvalue;
        
          }
          
        })
        .catch(ex => {
          alert('error-----',ex);
        });

    },

    displaydata(pageNof) {
      // alert(pageNo1);
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isBusy1 = true;
      // let temhubid = 
      if(userInfo.is_superadmin==1)
      {
         this.obj = {
            page_no:`${pageNof}`,
            service_id : this.service_id,
            is_superadmin : 1,
          };
      } else{
        this.obj = {
            page_no:`${pageNof}`,
            hub_id: `${userInfo.pickuplocationmasterid}`,
            is_superadmin : 0,
          };
      }

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/tobeOFDListing`, this.obj)
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            this.isBusy1 = !this.isBusy1;
            this.data = result.body.returnvalue;

            this.list_totalRows1 = result.body.returnvalue[0].totalcount;
            console.log(this.list_totalRows1, "DDDDDDDDDDDD");

            this.noofpagesofd = parseInt(this.list_totalRows1) / 20;

            this.noofpagesofd = Math.ceil(this.noofpagesofd);
            //this.items  = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length;
            // console.log(this.totalRows) ;
          } else {
            this.isBusy1 = !this.isBusy1;
            this.list_totalRows1=0;
            this.totalRows1 = 0;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },

   

    clickCallback (pageNum){
          this.listingpageno = pageNum;
        console.log("pageNum",this.listingpageno)
           this.expiredofdfunction(pageNum);
      },

    expiredofdfunction(pageNo) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(pageNo);
      this.isBusy = true;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      //console.log(userInfo);
      if(userInfo.is_superadmin==1)
      {
         this.obj = {
            page_no:`${pageNo}`,
            service_id : this.service_id,
            is_superadmin : 1,
          };
      } else{
        this.obj = {
            page_no:`${pageNo}`,
            hub_id: `${userInfo.pickuplocationmasterid}`,
            is_superadmin : 0,
          };
      }
      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/expiredOFDListing`, this.obj)
        .then((result) => {
          if (result.body.returnmsg === "Successful") {
            this.isBusy = !this.isBusy;
            this.data_exp = result.body.returnvalue;

            this.list_totalRows = result.body.returnvalue[0].totalcount;
            console.log(this.list_totalRows, "DDDDDDDDDDDD");

            this.noofpages = parseInt(this.list_totalRows) / 20;

            this.noofpages = Math.ceil(this.noofpages);

            //this.items  = result.body.returnvalue;
            this.totalRows_exp = result.body.returnvalue.length;
            // console.log(this.totalRows) ;
          } else {
            this.isBusy = !this.isBusy;
            this.list_totalRows=0;
            this.totalRows_exp = result.body.returnvalue.length;
          }
        })
        .catch((ex) => {
          console.log("error-----", ex);
        });
    },

    downloadCSV(value) {
      // gettobeOFDCSV
      // alert(this.countpage);
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      if(userInfo.is_superadmin==1)
      {
         this.obj = {
            service_id : this.service_id,
            is_superadmin : 1,
            type: value,
          sysusermasterid: `${userInfo.sysusermasterid}`,
          };
      } else{
        this.obj = {
            hub_id: `${userInfo.pickuplocationmasterid}`,
            type: value,
            is_superadmin : 0,
          sysusermasterid: `${userInfo.sysusermasterid}`,
          };
      }
      
      // console.log("ggggg", csvObj);
      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/gettobeOFDCSV`, this.obj)
        .then((result) => {
          if (result.body == "success") {
            // alert("Please Check Ur Mail For Downlod Link")
            this.$fire({
              text: "Please Check Your Mail For Downlod Link",
              type: "success",
              timer: 30000,
            });
          } else {
            // alert("Can not Download");
            this.$fire({
              text: "Can not Download",
              type: "error",
              timer: 30000,
            });
          }
        });
    },

     clearsearch: function(){
          this.service_id = "";
          this.data=[]
          this.pageNumofd=1;
          this.data_exp=[];
          this.pageNum=1;
          this. list_totalRows= 0;
          this.list_totalRows1=0;
          this.gethublist();
        }
  },
};
</script>

<style>
/* .tableOFD {
  overflow-x: scroll;
} */
</style>
